// 这里注册flutter要调用的js全局函数，flutter也只能调用window底下的全局方法
import { Toast } from 'vant';

// webview Toast轻提示
window._FlutterShowToast = function (msg) {
    Toast(msg)
}
